import { Link } from "react-router-dom";
import { Mail, MapPin, Clock } from "lucide-react";
import Logo from "@/components/Logo";
import GmtClock from "@/components/GmtClock";

export default function Footer() {
  return (
    <footer className="border-t border-slate-800/80 bg-[#070B14]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="space-y-5">
            <Logo />
            <p className="max-w-xs text-sm leading-relaxed text-slate-400">
              Premium UK career consultancy headquartered in Sheffield, crafted by UK HR professionals. British corporate insight at a fair price.
            </p>
            <GmtClock showStatus />
          </div>
          <div>
            <h4 className="overline-label mb-5">Services</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/services">Professional CV Writing</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/services">Cover Letter Crafting</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/services">LinkedIn Optimization</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/services">Interview Preparation</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/services">Ultimate UK Career Bundle</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="overline-label mb-5">Company</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/about">Why RMS Group</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/blog">The HR Insight</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/partnerships">University Partnerships</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/contact">Contact</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/order">Order / Intake</Link></li>
              <li><Link className="transition-colors hover:text-[#C5A059]" to="/auth">Client Portal</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="overline-label mb-5">Operations</h4>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3"><Clock size={16} className="mt-0.5 shrink-0 text-[#C5A059]" /><span>09:00 – 18:00 GMT/BST<br />Monday to Saturday</span></li>
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-[#C5A059]" /><span>Sheffield, United Kingdom (HQ)<br />Branch: Hyderabad, India</span></li>
              <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 shrink-0 text-[#C5A059]" /><span>hello.rmsgroup@gmail.com</span></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-slate-800/80 pt-8 text-xs text-slate-500 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} RMS Group — Resume Making Services Group. All rights reserved.</p>
          <p className="font-mono tracking-wider">100% BRITISH STANDARDS · ATS VERIFIED · SECURE GBP PAYMENTS</p>
        </div>
      </div>
    </footer>
  );
}
